export enum NAMESPACES {
  USER = 'user',
  LOCATION = 'location',
  MAP = 'map',
  DEVICES = 'devices',
  DEVICE_MODELS = 'devicemodels',
  ALERTS = 'alerts',
  SUBSCRIPTIONS = 'subscriptions',
  ADMIN_PANEL = 'adminpanel',
  DEVELOPER_PANEL = 'developerpanel',
  DEVICE_INTERVALS = 'deviceIntervals'
}
